import React from 'react';
import ReactDOMClient from 'react-dom/client';
import { loadableReady } from './loadable/loadable-ready.js';
const onRecoverableError = (error) => {
    var _a, _b;
    let errorCode = 'unknown';
    if (error) {
        const match = ('' + error).match(/#(\d+)/);
        if (match && match[1]) {
            errorCode = match[1];
        }
    }
    const errorMessage = `Hydration failure due to (#${errorCode}). React recovered from this error, but please investigate.`;
    console.error(errorMessage);
    try {
        if (typeof window !== 'undefined') {
            (_b = (_a = window.elasticApm) === null || _a === void 0 ? void 0 : _a.captureError) === null || _b === void 0 ? void 0 : _b.call(_a, new Error(errorMessage));
        }
    }
    catch (e) {
        console.warn('Unable to report hydration error due to', e);
    }
};
const onIgnoreRecoverableError = () => {
    console.debug('Hydration error suppressed');
};
const bootstrap18 = (App, options = {}) => {
    const { dangerouslySuppressRecoverableErrors = false, dangerouslyIgnoreRecoverableErrors = false } = options;
    const hydrationOptions = {};
    if (dangerouslyIgnoreRecoverableErrors) {
        hydrationOptions.onRecoverableError = onIgnoreRecoverableError;
    }
    else if (dangerouslySuppressRecoverableErrors) {
        hydrationOptions.onRecoverableError = onRecoverableError;
    }
    loadableReady(() => {
        const rootElement = document.getElementById('root');
        if (import.meta.env.DEV) {
            const root = ReactDOMClient === null || ReactDOMClient === void 0 ? void 0 : ReactDOMClient.createRoot(rootElement);
            root === null || root === void 0 ? void 0 : root.render(React.createElement(App, null));
        }
        else {
            ReactDOMClient === null || ReactDOMClient === void 0 ? void 0 : ReactDOMClient.hydrateRoot(rootElement, React.createElement(App, null), hydrationOptions);
        }
    });
};
export { bootstrap18 };
